import useHasPermissions from "../hooks/useHasPermissions";



export const NOTES_PERMISSIONS_STUB = {
  canView: true,
  canEdit: true,
  canDelete: true,
};

export default function useNotesPermissions() {
  const { hasPermissions } = useHasPermissions();

  return {
    canView: hasPermissions(["notes.view"]),
    canEdit: hasPermissions(["notes.edit"]),
    canDelete: hasPermissions(["notes.delete"]),
  };
}
